import { ItineraryStatus } from '../../../models/itinerary';
import { ActionTypes } from '../../constants/action-types';
import { ToggleConfirmDialogAction, UserNoteChangeAction } from './types';

export function toggleConfirmDialog(open: boolean, itineraryStatus: ItineraryStatus): ToggleConfirmDialogAction {
  return { type: ActionTypes.TOGGLE_CONFIRM_DIALOG, open, itineraryStatus };
}

export function updateUserNote(note: string): UserNoteChangeAction {
  return { type: ActionTypes.USER_NOTE_CHANGE, note };
}
